"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playersReducer = exports.playersActions = void 0;
const models_1 = require("@creature-chess/models");
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = [];
const updateLocalPlayer = (state, id, patch) => {
    const player = state.find((p) => p.id === id);
    if (player) {
        patch(player);
    }
};
exports.playersActions = {
    setLocalHealth: (0, toolkit_1.createAction)("players/setLocalHealth"),
    setLocalMoney: (0, toolkit_1.createAction)("players/setLocalMoney"),
    setLocalLevel: (0, toolkit_1.createAction)("players/setLocalLevel"),
    setLocalReady: (0, toolkit_1.createAction)("players/setLocalReady"),
    setLocalStreak: (0, toolkit_1.createAction)("players/setLocalStreak"),
    setLocalBattle: (0, toolkit_1.createAction)("players/setLocalBattle"),
    setLocalStatus: (0, toolkit_1.createAction)("players/setLocalStatus"),
};
exports.playersReducer = (0, toolkit_1.createReducer)(initialState, (builder) => {
    builder
        .addCase(models_1.GameEvents.playerListChangedEvent, (_state, action) => [
        ...action.payload.players,
    ])
        .addCase(exports.playersActions.setLocalHealth, (state, action) => {
        updateLocalPlayer(state, action.payload.id, (p) => {
            p.health = action.payload.health;
        });
    })
        .addCase(exports.playersActions.setLocalMoney, (state, action) => {
        updateLocalPlayer(state, action.payload.id, (p) => {
            p.money = action.payload.money;
        });
    })
        .addCase(exports.playersActions.setLocalLevel, (state, action) => {
        updateLocalPlayer(state, action.payload.id, (p) => {
            p.level = action.payload.level;
        });
    })
        .addCase(exports.playersActions.setLocalReady, (state, action) => {
        updateLocalPlayer(state, action.payload.id, (p) => {
            p.ready = action.payload.ready;
        });
    })
        .addCase(exports.playersActions.setLocalStreak, (state, action) => {
        updateLocalPlayer(state, action.payload.id, (p) => {
            p.streakType = action.payload.streakType;
            p.streakAmount = action.payload.streakAmount;
        });
    })
        .addCase(exports.playersActions.setLocalBattle, (state, action) => {
        updateLocalPlayer(state, action.payload.id, (p) => {
            p.battle = action.payload.battle;
        });
    })
        .addCase(exports.playersActions.setLocalStatus, (state, action) => {
        updateLocalPlayer(state, action.payload.id, (p) => {
            p.status = action.payload.status;
        });
    });
});
